<template>
  <div class="docs">
    <div class="col-md-12 jumbotron my-3 p-3 m-0 p-0">
      <table class="table table-responsive">
        <thead class="thead-light">
          <tr>
            <th scope="col">Booking ID</th>
            <th scope="col">Days</th>
            <th scope="col">Amount</th>
            <th>Source</th>
            <th>Payment ID</th>
            <th>Status</th>
            <th scope="col">Date</th>
            <th>Agent</th>
            <th>Comment</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in cx_collection" :key="index">
            <th scope="row">{{ data.bookingId }}</th>
            <td>{{ data.noOfDays }}</td>
            <td>
              <span class="badge badge-primary">{{
                data.amount | currency
              }}</span>
            </td>
            <td>{{ data.source }}</td>
            <td>{{ data.paymentId }}</td>
            <td>
              <span v-if="data.paymentStatus == 0" class="badge badge-danger"
                >Pending</span
              >
              <span v-if="data.paymentStatus == 1" class="badge badge-success"
                >Paid</span
              >
            </td>
            <td style="">
              <span class="">{{ data.createdAt | moment("LLL") }}</span>
            </td>
            <td>{{ agentName(data.createdBy) }}</td>
            <td>
              <span class="">{{ data.comment }}</span>
              <!-- <button type="button" class="btn btn-secondary" :data-toggle="'tooltip'+index" data-placement="top" title="Tooltip on top">
                Tooltip on top
              </button> -->
            </td>
          </tr>
        </tbody>
      </table>
      <div
        class="mt-5 col-md-12 text-center"
        v-if="cx_collection.length == 0 && !makingAJAX"
      >
        <p>We didn't get any data.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
    };
  },
  created() {
    this.$store.dispatch("get_agents");
    this.$store.state.customer_by_number = [];
    this.phone_number = this.$route.params.phone;
    this.cx_id = this.$route.params.cx_id;
    this.currentTab = this.$route.query.tab;
    if (this.phone_number) {
      this.$store.dispatch("get_customer_collection_history", {
        id: this.cx_id,
      });
    } else {
      this.showModal = true;
    }
  },
  methods: {
    agentName(id) {
      if (this.agents) {
        var agent = this.agents.filter((x) => {
          return x.id == id;
        });
        return agent.length > 0 ? agent[0].userName : "NA";
      } else {
        return;
      }
    },
  },
  watch: {},
  computed: {
    makingAJAX() {
      return this.$store.state.makingAJAX;
    },
    cx_collection() {
      return this.$store.state.collection_history || [];
    },
    agents() {
      return this.$store.state.agents;
    },
  },
};
</script>

<style></style>
